import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import { loadRuntimeConfig } from './runtimeConfig';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import '@/styles';

const rootElement = document.querySelector('#root');
if (!rootElement) throw new Error('No root element found!');

const root = createRoot(rootElement);

// Resolve /config.json before rendering so the app never issues a request
// against the wrong API. loadRuntimeConfig never rejects: when config.json is
// absent (as in production) it falls back to the build-time endpoint, so this
// cannot become a new production failure mode.
loadRuntimeConfig().then(() => {
  root.render(
    <Router>
      <App />
    </Router>,
  );
});
